class PasskeyDatatable {
    constructor(){
        this.datatable = this.init('#passkey-datatable');
        this.initActions();
    }
    init(el){
        let thisClass = this;
        const datatable = $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            order: [[0, 'desc']],
            info: true,
            paging: true,
            ajax: {
                url: '?do=getPasskeys',
                type: 'POST',
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=passkey-datatable_length]').select2({minimumResultsForSearch: -1});
                // Add delay to datatable search
                // new DatatableSearchDelay(datatable, '#sign_in_attempts_tab [data-kt-docs-table-filter=search]');
            },
            columns: [
                {
                    data: 'created_at',
                    title: 'Created At',
                    sortable: true,
                    render: function (data, type, row) {
                        return `<span>${row['created_at']}</span>`;
                    }
                },
                {
                    data: 'name',
                    title: 'Name',
                    sortable: false,
                    render: function (data, type, row) {
                        return `<span>${row['name']}</span>`;
                    }
                },
                {
                    data: null,
                    title: 'Actions',
                    sortable: false,
                    render: function (data, type, row) {
                        //add delete button
                        return `<div
                            class="btn btn-icon btn-bg-light btn-sm btn-active-color-primary delete-passkey cursor-pointer"
                            data-uuid="${row['id']}"
                            data-cy="thrash-can-member-btn" data-bs-toggle="popover" data-bs-placement="top"
                            data-bs-trigger="hover" data-bs-html="true" data-bs-content="Delete">
                                <span class="svg-icon svg-icon-3">                       
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">                           
                                        <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>                           
                                        <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>
                                        <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>                       
                                    </svg>
                                </span>
                            </div>`
                    },
                }
            ]
        }).on('draw.dt', function () {
            if (datatable.page.info().recordsTotal === 0) {
                $('#passkey-datatable_wrapper').hide();
                $('#passkey-datatable-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            } else {
                $('#passkey-datatable_wrapper').show();
                $('#passkey-datatable-datatable_no-results').addClass('d-none').removeClass('d-flex flex-center flex-column');
            }
        });
        return datatable;
    }

    initActions() {
        const thisClass = this;
        $(document).on('click', '.delete-passkey', function (e) {
            let passkeyID = $(this).attr('data-uuid');
            Swal.fire({
                html: `<span class="text-center text-primary">Are you sure you want to remove this passkey?</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, remove!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/security-settings?do=removePasskey&passkeyID='+passkeyID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if (result.value === 'success') {
                        toastr.success('Passkey has been removed successfully.');
                        thisClass.datatable.ajax.reload(null, false);
                    } else {
                        toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                    }
                }
            });
        });
    }
}
window.PasskeyDatatable = PasskeyDatatable;